import React from "react";
import PropTypes from "prop-types";

import { makeStyles } from "@material-ui/core/styles";

// @material-ui icons
import LocationOn from "@material-ui/icons/LocationOn";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import Carousel from "react-slick";

// @material-ui styles
import iStyles from "assets/jss/material-kit-react/imagesStyles.js";
import pStyles from "assets/jss/material-kit-react/views/landingPageSections/productStyle.js";
import cStyles from "assets/jss/material-kit-react/views/componentsSections/carouselStyle.js";

const styles = {
  ...iStyles,
  ...pStyles,
  ...cStyles,
};

const useStyles = makeStyles(styles);

export default function TripsCarusel(props) {
  const classes = useStyles();

  const settings = {
    dots: true,
    infinite: true,
    speed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  };

  return (
    <div>
      <GridContainer justifyContent="flex-start">
        <GridItem xs={12} sm={12} md={12} className={classes.marginAuto}>
          <Card carousel>
            <Carousel {...settings}>
              {props.images.map((image) => (
                <div key={image}>
                  <img src={image} alt="" className="slick-image" />
                  <div className="slick-caption">
                    <h4>
                      <LocationOn className="slick-icons" />
                      {props.location}
                    </h4>
                  </div>
                </div>
              ))}
            </Carousel>
          </Card>
        </GridItem>
      </GridContainer>
    </div>
  );
}

TripsCarusel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string),
  location: PropTypes.string,
};
